"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";

export const CCMT_LINKS = [
  { name: "Official CCMT Portal", url: "https://ccmt.admissions.nic.in/", highlight: true },
  { name: "CCMT 2026 Cutoffs", url: "https://admissions.nic.in/CCMT/Applicant/Report/orcrreport.aspx?enc=Nm7QwHILXclJQSv2YVS+7oyfr3QTMnD485kebzU4RQjHPShCZV1JNhAqXFSs1WVi" },
  { name: "CCMT 2025 Cutoffs", url: "https://admissions.nic.in/CCMT/Applicant/Report/orcrreport.aspx?enc=Nm7QwHILXclJQSv2YVS+7oyfr3QTMnD485kebzU4RQjHPShCZV1JNhAqXFSs1WVi" },
  { name: "CCMT 2024 Cutoffs", url: "https://admissions.nic.in/admiss/admissions/orcrjacd/105012421" },
  { name: "CCMT 2023 Cutoffs", url: "https://admissions.nic.in/admiss/admissions/orcrjacd/105012321" },
  { name: "CCMT 2022 Cutoffs", url: "https://admissions.nic.in/admiss/admissions/orcrjacd/105012221" },
  { name: "CCMT 2021 Cutoffs", url: "https://admissions.nic.in/admiss/admissions/orcrjacd/105012121" },
];

interface CcmtPortalsCardProps {
  isOpen: boolean;
  side?: "top" | "bottom";
  align?: "left" | "right";
  className?: string;
}

export function CcmtPortalsCard({ 
  isOpen, 
  side = "top", 
  align = "right",
  className 
}: CcmtPortalsCardProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: side === "top" ? 10 : -10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: side === "top" ? 10 : -10, scale: 0.95 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className={cn(
            "absolute z-50 w-64 overflow-hidden rounded-2xl border border-outline-variant/30 bg-surface-container-lowest shadow-2xl",
            side === "top" ? "top-full mt-3" : "bottom-full mb-4",
            align === "right" ? "right-0" : "left-0",
            className
          )}
        >
          <div className="p-4 bg-surface-container-low border-b border-outline-variant/10">
            <h3 className="text-sm font-bold text-foreground">Official CCMT Sites</h3>
            <p className="text-xs text-on-surface-variant">Access official portal & cutoffs</p>
          </div>
          <div className="p-2 flex flex-col gap-0.5">
            {CCMT_LINKS.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  "flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                  link.highlight
                    ? "bg-primary/10 text-primary font-bold hover:bg-primary/15"
                    : "text-on-surface hover:bg-surface-container"
                )}
              >
                {link.name}
                <ExternalLink className={cn("size-3.5", link.highlight ? "text-primary" : "text-on-surface-variant")} />
              </a>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
